/*
 * @Author: ç¯çç§æ(lucas huang)
 * @Date: 2018-11-07 16:31:57
 * @LastEditors: ç¯çç§æ(Lucas Huang)
 * @LastEditTime: 2019-09-27 14:57:22
 * @Company: Inspur
 * @Version: v0.0.1
 */

/**
 * ä½¿ç¨æ¹æ³ï¼
 * [data-mapping]="{ id: 'user.userId', name: 'user.userName' }"
 * key ä¸ºå¸®å©ä¸çå­æ®µï¼ value ä¸º è¡¨åä¸­çå­æ®µå
 * å¸®å©ä¸çåä¸ä¸ªå­æ®µå¯ä»¥æ å°å°è¡¨åä¸­çå¤ä¸ªå­æ®µä¸­ï¼{ ... id: 'user.userid, user.addusid'}
 * å¤å­æ®µä»¥éå·éå¼
 *
 */

import { Directive, OnInit, Optional, Self, Input } from '@angular/core';
import { BindingObject, NgFormControl, ViewModel } from '@farris/devkit';
import { LookupGridComponent } from '@farris/ui-lookup';
import { DataMapping } from './data-mapping';


@Directive({ selector: '[data-mapping]' })
export class LookupDataMappingDirective extends DataMapping implements OnInit {
  @Input('data-mapping') mapfields: any;
  @Input('target') target: BindingObject = null;

  constructor(@Optional() public vm: ViewModel, @Optional() @Self() private lookup: LookupGridComponent) {
    super();
  }

  ngOnInit() {
    this.lookup.selectedData.subscribe((data: any) => {
      const _mapfields = this.mapfields || this.lookup.mapFields;
      const spliter = this.lookup.multipleChoiceSeparator || this.defaultSpliter;
      this.mappingData(data, _mapfields, false, spliter);
    });
    this.lookup.clearMappings.subscribe((result: any) => {
      // const value = result && result.value || null;
      const mapfields = Object.assign({}, (this.mapfields || this.lookup.mapFields || {}));
      const lookupTextField = this.lookup.textField;
      const data = {};
      const controlName = this.lookup.ngControl && this.lookup.ngControl.name;
      if (controlName && this.vm) {
        const textFieldMapping = mapfields[lookupTextField];
        const ngFormControl = this.vm && this.vm.form && this.vm.form.ngFormControls && this.vm.form.ngFormControls[controlName] as NgFormControl;
        const binding = ngFormControl && ngFormControl.binding;
        if (textFieldMapping && binding) {
          mapfields[lookupTextField] = textFieldMapping.split(',').filter((item) => item !== binding).join(',');
        }
      }
      // this.setValue(data, lookupTextField.split('.'), value);
      Object.keys(mapfields).forEach((field) => {
        this.setValue(data, field.split('.'), '');
      });
      this.mappingData(data, mapfields, true);
    });
    this.lookup.clear.subscribe(() => {
      const _mapfields = this.mapfields || this.lookup.mapFields;
      this.mappingData(null, _mapfields);
    });
  }
}
